export default __webpack_public_path__ + "static/media/gallery - story - hand (1)_00.86dfbe01.jpg";